import { render } from "./ModalConfirmAuthorization.vue?vue&type=template&id=251c3264"
import script from "./ModalConfirmAuthorization.vue?vue&type=script&lang=js"
export * from "./ModalConfirmAuthorization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__